import { render } from "./FireModalConfirm.vue?vue&type=template&id=2e4b8aa4"
import script from "./FireModalConfirm.vue?vue&type=script&lang=ts"
export * from "./FireModalConfirm.vue?vue&type=script&lang=ts"
script.render = render

export default script